class ProductCardOptionOverflow {
  constructor(list) {
    this.list = list;
    this.items = Array.from(list.children).filter((item) => !item.hasAttribute('data-card-option-overflow'));
    this.overflowItem = list.querySelector('[data-card-option-overflow]');
    this.frame = null;

    if (!this.overflowItem || this.items.length === 0) {
      return;
    }

    this.resizeObserver = new ResizeObserver(() => this.scheduleLayout());
    this.resizeObserver.observe(list);
    this.scheduleLayout();
  }

  scheduleLayout() {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.layout());
  }

  layout() {
    this.items.forEach((item) => item.hidden = false);
    this.overflowItem.hidden = true;

    const availableWidth = this.list.clientWidth;

    if (availableWidth <= 0) {
      return;
    }

    const styles = getComputedStyle(this.list);
    const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
    const itemWidths = this.items.map((item) => item.getBoundingClientRect().width);
    const naturalWidth = itemWidths.reduce((total, width) => total + width, 0) + gap * Math.max(0, this.items.length - 1);

    if (naturalWidth <= availableWidth + 0.5) {
      return;
    }

    this.overflowItem.hidden = false;
    const overflowWidth = this.overflowItem.getBoundingClientRect().width;
    let usedWidth = 0;
    let visibleCount = 0;

    this.items.forEach((item, index) => {
      const itemWidth = itemWidths[index];
      const widthWithItem = usedWidth + (visibleCount > 0 ? gap : 0) + itemWidth;
      const requiredWidth = widthWithItem + gap + overflowWidth;

      if (requiredWidth <= availableWidth + 0.5) {
        usedWidth = widthWithItem;
        visibleCount += 1;
      } else {
        item.hidden = true;
      }
    });
  }
}

const initializedLists = new WeakSet();

function initializeOptionLists(root = document) {
  const lists = root.matches?.('[data-card-option-values]')
    ? [root]
    : root.querySelectorAll?.('[data-card-option-values]') || [];

  lists.forEach((list) => {
    if (!initializedLists.has(list)) {
      initializedLists.add(list);
      new ProductCardOptionOverflow(list);
    }
  });
}

initializeOptionLists();

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        initializeOptionLists(node);
      }
    });
  });
}).observe(document.documentElement, { childList: true, subtree: true });
